const pivotFieldsOf = (pivots) => (pivots != null ? pivots : []).flatMap((pivot) => pivot.fields);
const collectKeysByType = (data, config, fieldTypeOf, relevantTypes) => {
  const rowFields = pivotFieldsOf(config == null ? void 0 : config.rowPivots);
  const columnFields = pivotFieldsOf(config == null ? void 0 : config.columnPivots);
  const acc = {};
  const add = (field, value) => {
    var _a;
    if (!field || value === null || value === void 0) {
      return;
    }
    const type = fieldTypeOf(field);
    if (!type || !relevantTypes.has(type)) {
      return;
    }
    ((_a = acc[type]) != null ? _a : acc[type] = /* @__PURE__ */ new Set()).add(String(value));
  };
  const collectKey = (key, fields) => (key != null ? key : []).forEach((value, idx) => add(fields[idx], value));
  const visitRow = (row) => {
    if ("key" in row && Array.isArray(row.key)) {
      collectKey(row.key, rowFields);
    }
    if ("values" in row && Array.isArray(row.values)) {
      row.values.forEach((value) => {
        if (value.source === "col-leaf") {
          collectKey(value.key, columnFields);
        } else if ("values" in value) {
          visitRow(value);
        }
      });
    }
  };
  Object.entries(data).forEach(([dataset, rows]) => {
    if (dataset === "events" || !Array.isArray(rows)) {
      return;
    }
    rows.forEach(visitRow);
  });
  return Object.fromEntries(Object.entries(acc).map(([type, values]) => [type, Array.from(values)]));
};
export default collectKeysByType;
